module.exports = __webpack_public_path__ + "static/asset-555295b649c93dda5e90268da4f0a5c9.svg";